import { apiErrorMessage } from './ApiError';
import { axiosApi } from './axios.api';
import { RoleDataArray, RoleModel, RoleQueryParams } from '@app/interfaces/role';

const url = `/api/roles`;

export const getRolesApi = async (params?: RoleQueryParams): Promise<RoleDataArray | undefined> => {
  try {
    const response = await axiosApi.get<RoleDataArray>(url, { params });
    return response.data;

  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const getRoleApi = async (roleId: number) => {
  try {
    const response = await axiosApi.get(`${url}/${roleId}`);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const createRoleApi = async (data: RoleModel) => {
  try {
    const response = await axiosApi.post(url, data);
    return response.data;

  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const updateRoleApi = async (roleId: number, formData: RoleModel) => {
  try {
    const response = await axiosApi.put(`${url}/${roleId}`, formData);
    return response.data;

  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const deleteRoleApi = async (roleId: number) => {
  try {
    const response = await axiosApi.delete(`${url}/${roleId}`);
    return response.data;

  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const exportRoleApi = async (params?: Record<string, unknown>) => {
  try {
    const response = await axiosApi.get(`${url}/export`, { params, responseType: 'blob' });

    const newUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = newUrl;
    link.setAttribute('download', `roles.xlsx`);
    document.body.appendChild(link);
    link.click();

  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const assignUserRoleApi = async (roleId: number, formData: {user_ids: string[]}) => {
  try {
    const response = await axiosApi.post(`${url}/${roleId}/assign_user`, formData);
    return response.data;

  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const assignPermissionRoleApi = async (roleId: number, formData: {permission_ids: string[]}) => {
  try {
    const response = await axiosApi.post(`${url}/${roleId}/assign_permission`, formData);
    return response.data;

  } catch (error: any) {
    apiErrorMessage(error);
  }
};